import React, { useEffect, useState } from "react";

import AttendanceSummary from "./AttendanceSummary";
import MonitoringMetrics from "./MonitoringMetrics";
import RoleWiseContainer from "./RoleWiseCount";
import SalesTeamOverview from "./SalesTeamOverview";
import TerritoryCoverage from "./TerritoryCoverage";
import TerritoryCoverageMap from "./DashboardTopbar";
import DashboardTopbar from "./DashboardTopbar";
import TopSalesPerformers from "./TopSalesPerformers";
import MarketExecutionOverview from "./SalesTeamTarget";
import BusinessOperationsOverview from "./SalesTeamAudit";
import LeaveOverview from "./SalesTeamClaim";

const STORAGE_KEY = "sales-dashboard-settings";

export default function SalesAdminDashboard() {
  const defaultSections = {
    salesTeamOverview: true,
    roleWise: true,
    territoryCoverage: true,
    attendanceSummary: true,
    monitoringMetrics: true,
  };

  const [openPopup, setOpenPopup] = useState(false);

  const [sections, setSections] = useState(defaultSections);
  const [compareMode, setCompareMode] = useState(false);
  const [rememberSettings, setRememberSettings] = useState(false);

  const REGION_STORAGE_KEY = "sales-dashboard-regions";
  const defaultRegions = {
    eastIndia: true,
    westIndia: true,
    southIndia: true,
    northIndia: true,
  };

  const [openRegionPopup, setOpenRegionPopup] = useState(false);

  const [regions, setRegions] = useState(defaultRegions);
  const selectedRegions = Object.keys(regions).filter((key) => regions[key]);

  const [rememberRegions, setRememberRegions] = useState(false);
  useEffect(() => {
    const saved = localStorage.getItem(REGION_STORAGE_KEY);

    if (saved) {
      const parsed = JSON.parse(saved);

      setRegions(parsed.regions);
      setRememberRegions(parsed.rememberRegions);
    }
  }, []);

  useEffect(() => {
    if (rememberRegions) {
      localStorage.setItem(
        REGION_STORAGE_KEY,
        JSON.stringify({
          regions,
          rememberRegions,
        }),
      );
    } else {
      localStorage.removeItem(REGION_STORAGE_KEY);
    }
  }, [regions, rememberRegions]);
  // Load saved settings
  useEffect(() => {
    const saved = localStorage.getItem(STORAGE_KEY);

    if (saved) {
      const parsed = JSON.parse(saved);

      setSections(parsed.sections);
      setRememberSettings(parsed.rememberSettings);
    }
  }, []);

  // Save settings
  useEffect(() => {
    if (rememberSettings) {
      localStorage.setItem(
        STORAGE_KEY,
        JSON.stringify({
          sections,
          rememberSettings,
        }),
      );
    } else {
      localStorage.removeItem(STORAGE_KEY);
    }
  }, [sections, rememberSettings]);
  const handleRegionCheckbox = (key) => {
    setRegions((prev) => ({
      ...prev,
      [key]: !prev[key],
    }));
  };

  const handleRegionCheckAll = () => {
    const allSelected = Object.values(regions).every(Boolean);

    const updated = {};

    Object.keys(regions).forEach((key) => {
      updated[key] = !allSelected;
    });

    setRegions(updated);
  };
  const handleCheckbox = (key) => {
    setSections((prev) => ({
      ...prev,
      [key]: !prev[key],
    }));
  };

  const handleCheckAll = () => {
    const allSelected = Object.values(sections).every(Boolean);

    const updated = {};

    Object.keys(sections).forEach((key) => {
      updated[key] = !allSelected;
    });

    setSections(updated);
  };

  const renderDashboard = (regionName) => (
    <>
      {sections.salesTeamOverview && <SalesTeamOverview region={regionName} />}

      {sections.salesTeamOverview && <TopSalesPerformers region={regionName} />}

      {sections.attendanceSummary && <AttendanceSummary region={regionName} />}

      {sections.roleWise && <RoleWiseContainer region={regionName} />}

      {sections.territoryCoverage && <TerritoryCoverage region={regionName} />}

      {sections.monitoringMetrics && <MonitoringMetrics region={regionName} />}

      {sections.monitoringMetrics && (
        <MarketExecutionOverview region={regionName} />
      )}

      {sections.monitoringMetrics && (
        <BusinessOperationsOverview region={regionName} />
      )}

      {sections.monitoringMetrics && (
        <LeaveOverview region={regionName} />
      )}
    </>
  );
  let whatsappWindow = null;

  const openWhatsAppChat = (mobile, name) => {
    const text = `Hello ${name}`;

    const url = `https://web.whatsapp.com/send?phone=${mobile}&text=${encodeURIComponent(
      text,
    )}`;

    // If already opened
    if (whatsappWindow && !whatsappWindow.closed) {
      whatsappWindow.location.href = url;
      whatsappWindow.focus();
    } else {
      // Open new tab first time only
      whatsappWindow = window.open(url, "WhatsAppWeb");
    }
  };

  return (
    <div
      style={{
        fontFamily: "'Inter', 'Segoe UI', sans-serif",
        background: "#F8FAFC",
        minHeight: "100vh",
        padding: "24px 20px",
        margin: "0 auto",
        position: "relative",
      }}
    >
      <button
        onClick={() => openWhatsAppChat("919834682306", "Rahul")}
        style={{
          background: "#25D366",
          color: "#fff",
          border: "none",
          padding: "10px 16px",
          borderRadius: 8,
          cursor: "pointer",
          fontWeight: 600,
        }}
      >
        WhatsApp
      </button>
      {/* Floating Settings Button */}
      <button
        onClick={() => setOpenRegionPopup(true)}
        style={{
          position: "fixed",
          bottom: 105,
          right: 30,
          width: 60,
          height: 60,
          borderRadius: "50%",
          border: "none",
          background: "#0F766E",
          color: "#fff",
          fontSize: 24,
          cursor: "pointer",
          boxShadow: "0 10px 25px rgba(0,0,0,0.15)",
          zIndex: 999,
        }}
      >
        🌍
      </button>

      <button
        onClick={() => setOpenPopup(true)}
        style={{
          position: "fixed",
          bottom: 30,
          right: 30,
          width: 60,
          height: 60,
          borderRadius: "50%",
          border: "none",
          background: "#2563EB",
          color: "#fff",
          fontSize: 24,
          cursor: "pointer",
          boxShadow: "0 10px 25px rgba(0,0,0,0.15)",
          zIndex: 999,
        }}
      >
        ⚙️
      </button>

      {/* Popup */}
      {openRegionPopup && (
        <>
          {/* Overlay */}
          <div
            onClick={() => setOpenRegionPopup(false)}
            style={{
              position: "fixed",
              inset: 0,
              background: "transparent",
              zIndex: 999,
            }}
          />

          {/* Popup */}
          <div
            style={{
              position: "fixed",
              bottom: 105,
              right: 105,
              width: 340,
              background: "#fff",
              borderRadius: 18,
              padding: 24,
              boxShadow: "0 20px 45px rgba(0,0,0,0.18)",
              zIndex: 1000,
              animation: "settingsPopup 0.28s ease",
              transformOrigin: "bottom right",
            }}
          >
            {/* Header */}
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                marginBottom: 20,
              }}
            >
              <h3
                style={{
                  margin: 0,
                  fontSize: 20,
                  color: "#0F172A",
                }}
              >
                Select Region
              </h3>

              <button
                onClick={() => setOpenRegionPopup(false)}
                style={{
                  border: "none",
                  background: "#F1F5F9",
                  width: 32,
                  height: 32,
                  borderRadius: 8,
                  fontSize: 16,
                  cursor: "pointer",
                }}
              >
                ✖
              </button>
            </div>

            {/* Check All */}

            <label
              style={{
                display: "flex",
                alignItems: "center",
                gap: 10,
                marginBottom: 18,
                fontWeight: 700,
                color: "#1E293B",
              }}
            >
              <input
                type="checkbox"
                checked={Object.values(regions).every(Boolean)}
                onChange={handleRegionCheckAll}
              />
              Check All
            </label>

            {/* Regions */}

            <SettingsItem
              label="East India"
              checked={regions.eastIndia}
              onChange={() => handleRegionCheckbox("eastIndia")}
            />

            <SettingsItem
              label="West India"
              checked={regions.westIndia}
              onChange={() => handleRegionCheckbox("westIndia")}
            />

            <SettingsItem
              label="South India"
              checked={regions.southIndia}
              onChange={() => handleRegionCheckbox("southIndia")}
            />

            <SettingsItem
              label="North India"
              checked={regions.northIndia}
              onChange={() => handleRegionCheckbox("northIndia")}
            />

            {/* Remember */}

            <div
              style={{
                marginTop: 20,
                paddingTop: 16,
                borderTop: "1px solid #E2E8F0",
              }}
            >
              <label
                style={{
                  display: "flex",
                  alignItems: "center",
                  gap: 10,
                  fontSize: 14,
                  fontWeight: 600,
                  color: "#334155",
                }}
              >
                <input
                  type="checkbox"
                  checked={rememberRegions}
                  onChange={() => setRememberRegions(!rememberRegions)}
                />
                Remember My Regions
              </label>
            </div>
            {selectedRegions.length === 2 && (
              <button
                onClick={() => setCompareMode(!compareMode)}
                style={{
                  padding: "10px 20px",
                  width: "stretch",
                  borderRadius: 14,
                  border: "none",
                  background: compareMode ? "#DC2626" : "#7C3AED",
                  color: "#fff",
                  fontWeight: 700,
                  fontSize: 14,
                  cursor: "pointer",
                  boxShadow: "0 10px 25px rgba(0,0,0,0.18)",
                  zIndex: 999,
                  transition: "all 0.25s ease",
                }}
              >
                {compareMode ? "Close Compare" : "Compare Regions"}
              </button>
            )}
          </div>
        </>
      )}

      {openPopup && (
        <>
          {/* Overlay */}
          <div
            onClick={() => setOpenPopup(false)}
            style={{
              position: "fixed",
              inset: 0,
              background: "transparent",
              zIndex: 999,
            }}
          />

          {/* Popup */}
          <div
            style={{
              position: "fixed",
              bottom: 30,
              right: 105,
              width: 360,
              background: "#fff",
              borderRadius: 18,
              padding: 24,
              boxShadow: "0 20px 45px rgba(0,0,0,0.18)",
              zIndex: 1000,

              animation: "settingsPopup 0.28s ease",
              transformOrigin: "bottom right",
            }}
          >
            {/* Header */}

            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                marginBottom: 20,
              }}
            >
              <h3
                style={{
                  margin: 0,
                  fontSize: 20,
                  color: "#0F172A",
                }}
              >
                Dashboard Settings
              </h3>

              <button
                onClick={() => setOpenPopup(false)}
                style={{
                  border: "none",
                  background: "#F1F5F9",
                  width: 32,
                  height: 32,
                  borderRadius: 8,
                  fontSize: 16,
                  cursor: "pointer",
                }}
              >
                ✖
              </button>
            </div>

            {/* Check All */}

            <label
              style={{
                display: "flex",
                alignItems: "center",
                gap: 10,
                marginBottom: 18,
                fontWeight: 700,
                color: "#1E293B",
              }}
            >
              <input
                type="checkbox"
                checked={Object.values(sections).every(Boolean)}
                onChange={handleCheckAll}
              />
              Check All
            </label>

            {/* Component List */}

            <SettingsItem
              label="Sales Team Overview"
              checked={sections.salesTeamOverview}
              onChange={() => handleCheckbox("salesTeamOverview")}
            />

            <SettingsItem
              label="Role Wise Count"
              checked={sections.roleWise}
              onChange={() => handleCheckbox("roleWise")}
            />

            <SettingsItem
              label="Territory Coverage"
              checked={sections.territoryCoverage}
              onChange={() => handleCheckbox("territoryCoverage")}
            />

            <SettingsItem
              label="Attendance Summary"
              checked={sections.attendanceSummary}
              onChange={() => handleCheckbox("attendanceSummary")}
            />

            <SettingsItem
              label="Monitoring Metrics"
              checked={sections.monitoringMetrics}
              onChange={() => handleCheckbox("monitoringMetrics")}
            />

            {/* Remember Setting */}

            <div
              style={{
                marginTop: 20,
                paddingTop: 16,
                borderTop: "1px solid #E2E8F0",
              }}
            >
              <label
                style={{
                  display: "flex",
                  alignItems: "center",
                  gap: 10,
                  fontSize: 14,
                  fontWeight: 600,
                  color: "#334155",
                }}
              >
                <input
                  type="checkbox"
                  checked={rememberSettings}
                  onChange={() => setRememberSettings(!rememberSettings)}
                />
                Remember My Settings
              </label>
            </div>

            {/* Animation */}
            <style>
              {`
          @keyframes settingsPopup {
            0% {
              opacity: 0;
              transform: translateX(25px) scale(0.85);
            }

            100% {
              opacity: 1;
              transform: translateX(0px) scale(1);
            }
          }
        `}
            </style>
          </div>
        </>
      )}

      {/* Dashboard Components */}

      {/* {sections.salesTeamOverview && <SalesTeamOverview />}

      {sections.roleWise && <RoleWiseContainer />}

      {sections.territoryCoverage && <TerritoryCoverage />}

      {sections.attendanceSummary && <AttendanceSummary />}

      {sections.monitoringMetrics && <MonitoringMetrics />} */}

      {/* Dashboard Components */}

      {compareMode ? (
        <div
          style={{
            display: "grid",
            gridTemplateColumns: "1fr 1fr",
            gap: 24,
            alignItems: "start",
            marginTop: 20,
          }}
        >
          {/* Left Region */}

          <div
            style={{
              background: "#FFFFFF",
              borderRadius: 20,
              padding: 20,
              border: "1px solid #E2E8F0",
              minHeight: "100vh",
            }}
          >
            {/* Region Header */}

            <div
              style={{
                position: "sticky",
                top: 0,
                zIndex: 10,
                background: "#fff",
                paddingBottom: 14,
                marginBottom: 20,
                borderBottom: "2px solid #E2E8F0",
              }}
            >
              <div
                style={{
                  fontSize: 22,
                  fontWeight: 800,
                  color: "#0F172A",
                  display: "flex",
                  alignItems: "center",
                  gap: 10,
                }}
              >
                📍 {selectedRegions[0]}
              </div>

              <div
                style={{
                  marginTop: 6,
                  fontSize: 13,
                  color: "#64748B",
                }}
              >
                Region Analytics Dashboard
              </div>
            </div>

            {/* Components */}

            {sections.salesTeamOverview && (
              <SalesTeamOverview region={selectedRegions[0]} />
            )}

            {sections.attendanceSummary && (
              <AttendanceSummary region={selectedRegions[0]} />
            )}

            {sections.salesTeamOverview && (
              <TopSalesPerformers region={selectedRegions[0]} />
            )}

            {sections.roleWise && (
              <RoleWiseContainer region={selectedRegions[0]} />
            )}

            {sections.territoryCoverage && (
              <TerritoryCoverage region={selectedRegions[0]} />
            )}

            {sections.monitoringMetrics && (
              <MonitoringMetrics region={selectedRegions[0]} />
            )}

            {sections.monitoringMetrics && (
              <MarketExecutionOverview region={selectedRegions[0]} />
            )}

            {sections.monitoringMetrics && (
              <BusinessOperationsOverview region={selectedRegions[0]} />
            )}

            {sections.monitoringMetrics && (
              <LeaveOverview region={selectedRegions[0]} />
            )}
          </div>

          {/* Right Region */}

          <div
            style={{
              background: "#FFFFFF",
              borderRadius: 20,
              padding: 20,
              border: "1px solid #E2E8F0",
              minHeight: "100vh",
            }}
          >
            {/* Region Header */}

            <div
              style={{
                position: "sticky",
                top: 0,
                zIndex: 10,
                background: "#fff",
                paddingBottom: 14,
                marginBottom: 20,
                borderBottom: "2px solid #E2E8F0",
              }}
            >
              <div
                style={{
                  fontSize: 22,
                  fontWeight: 800,
                  color: "#0F172A",
                  display: "flex",
                  alignItems: "center",
                  gap: 10,
                }}
              >
                📍 {selectedRegions[1]}
              </div>

              <div
                style={{
                  marginTop: 6,
                  fontSize: 13,
                  color: "#64748B",
                }}
              >
                Region Analytics Dashboard
              </div>
            </div>

            {/* Components */}

            {sections.salesTeamOverview && (
              <SalesTeamOverview region={selectedRegions[1]} />
            )}

            {sections.attendanceSummary && (
              <AttendanceSummary region={selectedRegions[1]} />
            )}

            {sections.salesTeamOverview && (
              <TopSalesPerformers region={selectedRegions[1]} />
            )}

            {sections.roleWise && (
              <RoleWiseContainer region={selectedRegions[1]} />
            )}

            {sections.territoryCoverage && (
              <TerritoryCoverage region={selectedRegions[1]} />
            )}

            {sections.monitoringMetrics && (
              <MonitoringMetrics region={selectedRegions[1]} />
            )}

            {sections.monitoringMetrics && (
              <MarketExecutionOverview region={selectedRegions[1]} />
            )}

            {sections.monitoringMetrics && (
              <BusinessOperationsOverview region={selectedRegions[1]} />
            )}

            {sections.monitoringMetrics && (
              <LeaveOverview region={selectedRegions[1]} />
            )}
          </div>
        </div>
      ) : (
        <>
          {sections.salesTeamOverview && (
            <SalesTeamOverview region={selectedRegions[0]} />
          )}

          {sections.attendanceSummary && (
            <AttendanceSummary region={selectedRegions[0]} />
          )}

          {sections.salesTeamOverview && (
            <TopSalesPerformers region={selectedRegions[0]} />
          )}

          {sections.roleWise && (
            <RoleWiseContainer region={selectedRegions[0]} />
          )}

          {sections.territoryCoverage && (
            <TerritoryCoverage region={selectedRegions[0]} />
          )}

          {sections.monitoringMetrics && (
            <MonitoringMetrics region={selectedRegions[0]} />
          )}

          {sections.monitoringMetrics && (
            <MarketExecutionOverview region={selectedRegions[0]} />
          )}

          {sections.monitoringMetrics && (
            <BusinessOperationsOverview region={selectedRegions[0]} />
          )}

          {sections.monitoringMetrics && (
            <LeaveOverview region={selectedRegions[0]} />
          )}
        </>
      )}
    </div>
  );
}

function SettingsItem({ label, checked, onChange }) {
  return (
    <label
      style={{
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        padding: "12px 0",
        borderBottom: "1px solid #F1F5F9",
        fontSize: 15,
        color: "#334155",
        cursor: "pointer",
      }}
    >
      {label}

      <input type="checkbox" checked={checked} onChange={onChange} />
    </label>
  );
}
